const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		usage: 'management',
		resourceConnected: false,
	},

	model: {
		forwardFilterChanges: false,
		forceViewChange: false
	},

	events: {
		refresh: {
			type: 'click',
			selector: 'button[data-field-type="refresh"]',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				if(event.data.component.model.activityTable){
					event.data.component.model.activityTable.refreshData();
				}
			}
		}
	},

	methods: {
		onChange: function(isRelationChange, changeDone, fieldData){
			if(this.model.forwardFilterChanges && this.model.activityTable){
				var data = (this.model.dirtyFields || {}).data || {};
				var attributes = data.attributes || {};

				if(this.model.forceViewChange){
					getComponent('artCrmController').propertiesFormChangeView('activity', {
						$container: 	this.$,
						usage: 			this.config.usage
					});
				}

				this.model.activityTable.onFilterChanged(
					attributes,
					isRelationChange ? !(fieldData || {}).isLastRelationElement : false,
					isRelationChange ? (fieldData || {}).isLastRelationElement : false
				);
			}
		},
		submit: function(){}
	},

	hooks: {
		_attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_artCrm_entity_controller', function(controller){
					self.model.controller = controller;
				});
			}
			if(!self.model.activityTable && self.model.controller){
				self.model.controller.find('templates_artCrm_activity_table', function(table){
					self.model.activityTable = table;
				});
			}

			this.model.forwardFilterChanges = true;
			this.config.usage = self.model.controller.config.usage;
			if(this.config.usage === 'selection'){
				var selectionRegisterContent = this.getResourceRegisterContent('selection') || {};
				utils.refReplace(this.model.dirtyFields, {
					data: {
						attributes: selectionRegisterContent
					}
				});
			}
			if(Object.keys(((this.model.dirtyFields || {}).data || {}).attributes || {}).length > 0){
				this.model.forceViewChange = true;
				this.onChange();
				this.model.forceViewChange = false;
			}
		}
	}
}